import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &.ReactModal__Overlay {\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: ", ";\n    inset: 0;\n    border: none;\n    opacity: 0;\n    transition: opacity ", "ms ease-in-out;\n    z-index: ", ";\n  }\n  &.ReactModal__Overlay--after-open {\n    opacity: 1;\n  }\n  &.ReactModal__Overlay--before-close {\n    opacity: 0;\n  }\n  &.ReactModal__Content {\n    border: none;\n    width: ", ";\n  }\n  &.ReactModal__Content:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import ReactModal from 'react-modal';
import posed from 'react-pose';
import styled from '../utils/styling/styled-components';
import { MODAL_BODY } from '../utils/testing/TestIDs';
var ANIMATION_DURATION = 250;
var Body = styled(posed.div({
  enter: {
    scale: 1,
    transition: {
      scale: {
        damping: 25,
        stiffness: 850,
        type: 'spring'
      }
    }
  },
  exit: {
    scale: 0.5,
    transition: {
      scale: {
        damping: 25,
        stiffness: 850,
        type: 'spring'
      }
    }
  }
}))(_templateObject());

var CustomModal = function CustomModal(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(ReactModal, _extends({
    className: className,
    overlayClassName: className
  }, props));
};

var StyledModal = styled(CustomModal)(_templateObject2(), function (props) {
  return props.hasOverlayBackground ? "rgba(54, 63, 65, 0.6)" : 'initial';
}, ANIMATION_DURATION, function (props) {
  return props.zIndexOverride ? props.zIndexOverride : 99;
}, function (props) {
  return props.width && "".concat(props.width, "px");
});
export var BaseModal = function BaseModal(_ref2) {
  var accessibilityProperties = _ref2.accessibilityProperties,
      children = _ref2.children,
      _ref2$hasOverlayBackg = _ref2.hasOverlayBackground,
      hasOverlayBackground = _ref2$hasOverlayBackg === void 0 ? true : _ref2$hasOverlayBackg,
      isOpen = _ref2.isOpen,
      _ref2$isTrapModal = _ref2.isTrapModal,
      isTrapModal = _ref2$isTrapModal === void 0 ? false : _ref2$isTrapModal,
      onCloseComplete = _ref2.onCloseComplete,
      onOpenComplete = _ref2.onOpenComplete,
      onRequestClose = _ref2.onRequestClose,
      zIndexOverride = _ref2.zIndexOverride,
      width = _ref2.width,
      rest = _objectWithoutProperties(_ref2, ["accessibilityProperties", "children", "hasOverlayBackground", "isOpen", "isTrapModal", "onCloseComplete", "onOpenComplete", "onRequestClose", "zIndexOverride", "width"]);

  var appElement = document.getElementById('app') || document.getElementById('root') || document.getElementById('webviews');

  if (process.env.NODE_ENV === 'development' && !appElement) {
    console.warn("Your application must have the ID of \"app\", \"root\", or \"webviews\" on it's top-level element");
    appElement = document.body;
  }

  if (process.env.NODE_ENV !== 'production' && !(accessibilityProperties === null || accessibilityProperties === void 0 ? void 0 : accessibilityProperties.labelledBy) && isTrapModal) {
    throw new Error("Please define the 'labelledBy' prop when using a trap modal (when 'isTrapModal' is true)!");
  }

  return /*#__PURE__*/React.createElement(StyledModal, {
    zIndexOverride: zIndexOverride,
    width: width,
    appElement: appElement,
    ariaHideApp: process.env.NODE_ENV !== 'test' // doing this prevents warnings in tests about not integrating `react-modal` accessibly.
    ,
    closeTimeoutMS: ANIMATION_DURATION,
    hasOverlayBackground: hasOverlayBackground,
    isOpen: isOpen,
    onAfterClose: onCloseComplete,
    onAfterOpen: onOpenComplete,
    onRequestClose: onRequestClose,
    role: isTrapModal ? 'alertdialog' : 'dialog',
    shouldCloseOnEsc: !isTrapModal,
    shouldCloseOnOverlayClick: !isTrapModal,
    shouldFocusAfterRender: true // Modals must trap focus on open for A11Y
    ,
    shouldReturnFocusAfterClose: true // Modals must always give back focus for A11Y

  }, /*#__PURE__*/React.createElement(Body, _extends({
    "aria-describedby": accessibilityProperties === null || accessibilityProperties === void 0 ? void 0 : accessibilityProperties.describedBy,
    "aria-labelledby": accessibilityProperties === null || accessibilityProperties === void 0 ? void 0 : accessibilityProperties.labelledBy,
    "data-testid": MODAL_BODY,
    initialPose: "exit",
    pose: isOpen ? 'enter' : 'exit'
  }, rest), children));
};